import React from "react";
import { StyledSwipeableDrawer, StyledTypography } from "../../../../../styled-mui";
import MobileMenuWrapper from "../MobileMenuWrapper";
import { useNavigate } from "react-router";
import useFetchWpPosts from "../../../../../_foundation/hooks/use-wordpress-posts";
import { StyledMenuButton } from "../../style";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box } from "@mui/material";
import { ImageLayout } from "../../../../elements/image";
import HTMLReactParser from "html-react-parser";
import { StyledChip } from "../../../../../../src/styled-mui/chip/styled-chip";
import SmartLink from "../../../../elements/smart-link/smart-link";
import AsyncCall from "../../../../../_foundation/gtm/async.service";
import storeUtil from "../../../../../utils/storeUtil";
import { CLICK } from "../../../../../_foundation/constants/gtm";

interface Props {
  open: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu: () => any;
  menuLinksData: Record<string, any>;
  pageParams?: Record<string, any> | null;
  categories?: Record<string, any>[];
  pathname?: string;
}

const MobileInspirationsMenu: React.FC<Props> = ({
  open,
  entireMenuCloseHandler,
  closeCurrentMenu,
  menuLinksData,
  pageParams = null,
  categories = [],
  pathname = "",
}) => {
  const navigate = useNavigate();
  const InspirationData = menuLinksData?.magazine;
  const { data: wpPostData } = useFetchWpPosts(!!InspirationData?.postsId, { postsId: InspirationData?.postsId });
  const NAV_LEVEL_1 = "Inspiration & Conseils";

  const onAdviceCardClick = (item: Record<string, any>) => {
    // AsyncCall.sendClick(CLICK.NAV, {
    //   click_section: "menu",
    //   nav_level_1: NAV_LEVEL_1,
    //   nav_level_2: "Advices",
    //   nav_level_3: "",
    //   nav_type: "link",
    //   btn_label: item?.label || "",
    //   click_destination: item?.link || "",
    // });
    AsyncCall.sendPageClickCtaEvent({ btn_label: item?.label || "" });
    entireMenuCloseHandler();
  };

  const onParUniverseItemClick = (item: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "Par univers",
      nav_level_3: item?.label || "",
      nav_type: "link",
      btn_label: item?.label || "",
      click_destination: item?.link || "",
    });
    entireMenuCloseHandler();
  };

  const onParTypeItemClick = (item: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "Par type",
      nav_level_3: item?.label || "",
      nav_type: "link",
      btn_label: item?.label || "",
      click_destination: item?.link || "",
    });
    entireMenuCloseHandler();
  };

  const isMagazineItem = (item: Record<string, any> | string) => {
    if (!item) return false;
    const label = (typeof item === "string" ? item : item?.label || item?.title || "").toString().toLowerCase();
    const url = (typeof item === "string" ? item : item?.link || item?.url || item?.link?.url || "")
      .toString()
      .toLowerCase();
    if (menuLinksData?.magazine && menuLinksData.magazine.label) {
      return label === menuLinksData.magazine.label.toString().toLowerCase();
    }
    return url.includes("magazine") || label.includes("magazine");
  };

  const shouldObfuscate = (item: Record<string, any>) => {
    if (!item) return false;
    const pageType = pageParams?.page?.type || "";
    if (typeof pageType === "string" && pageType.toLowerCase().includes("product")) return true;
    if (typeof pageType === "string" && pageType.toLowerCase().includes("category")) {
      if (isMagazineItem(item)) return true;
      const currentIdentifier = pageParams?.identifier || pageParams?.tokenValue || null;
      const currentParent = pageParams?.parentCategoryId || null;
      if (!currentParent) {
        const itemIdentifier = item?.identifier || item?.label || item?.title || "";
        const isTopLevel = categories?.some((c) => c?.identifier === itemIdentifier);
        return !isTopLevel;
      }
      const itemIdentifier2 = item?.identifier || item?.label || item?.title || "";
      const isSisterOrCurrent =
        itemIdentifier2 === currentIdentifier || categories?.some((c) => c?.identifier === itemIdentifier2);
      return !isSisterOrCurrent;
    }
    return false;
  };

  const onButtonClick = () => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "",
      nav_level_3: "",
      nav_type: "cta",
      btn_label: "Voir tous nos articles",
      click_destination: InspirationData?.url || "",
    });
    entireMenuCloseHandler();
    navigate("/c/magazine");
  };

  return (
    <StyledSwipeableDrawer
      anchor="left"
      open={open}
      onClose={closeCurrentMenu}
      onOpen={() => null}
      className="header-menu-level2 mobile-inspirations-menu">
      <MobileMenuWrapper
        title="Inspiration & conseils"
        isASubMenu
        entireMenuCloseHandler={entireMenuCloseHandler}
        closeCurrentMenu={closeCurrentMenu}>
        <Box padding={3}>
          {wpPostData &&
            wpPostData?.map((wpPost: Record<string, any>, index: number) => {
              const featuredMedia = wpPost?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes;
              const imgSrc = featuredMedia?.medium_large?.source_url || featuredMedia?.medium?.source_url || "";
              const imgAltText = wpPost?._embedded?.["wp:featuredmedia"]?.[0]?.alt_text || "";
              const chipName = HTMLReactParser(wpPost?._embedded["wp:term"]?.[0]?.[0]?.name) || "";
              const title = HTMLReactParser(wpPost?.title?.rendered) || "";
              const obfuscate = shouldObfuscate({ label: title, link: wpPost?.link });
              return obfuscate ? (
                <div
                  key={wpPost?.id}
                  className="inspiration-mobile-card"
                  role="link"
                  tabIndex={0}
                  style={{
                    display: "flex",
                    border: "1px solid rgba(224, 224, 224, 1)",
                    borderRadius: 8,
                    marginBottom: 12,
                    overflow: "hidden",
                  }}
                  onClick={() => {
                    onAdviceCardClick({ label: title, link: wpPost?.link });
                    window.open(wpPost?.link, "_blank");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onAdviceCardClick({ label: title, link: wpPost?.link });
                      window.open(wpPost?.link, "_blank");
                    }
                  }}>
                  <ImageLayout src={imgSrc} alt={imgAltText} width={90} styles={{ margin: "unset" }} />
                  <Box padding={3}>
                    <StyledChip size="small" label={chipName} variant="outlined" className="white" />
                    <StyledTypography
                      variant="subtitle2"
                      component="p"
                      className="advice-card-title"
                      style={{
                        fontSize: "13px",
                        lineHeight: "16px",
                        marginTop: "4px",
                        color: "#212121",
                      }}>
                      {title}
                    </StyledTypography>
                  </Box>
                </div>
              ) : (
                <SmartLink
                  isExternal
                  className="inspiration-mobile-card"
                  key={wpPost?.id}
                  to={wpPost?.link}
                  onClick={() => onAdviceCardClick({ label: title, link: wpPost?.link })}
                  styles={{
                    display: "flex",
                    border: "1px solid rgba(224, 224, 224, 1)",
                    borderRadius: "8px",
                    marginBottom: "12px",
                    overflow: "hidden",
                  }}>
                  <ImageLayout src={imgSrc} alt={imgAltText} width={90} styles={{ margin: "unset" }} />
                  <Box padding={3}>
                    <StyledChip size="small" label={chipName} variant="outlined" className="white" />
                    <StyledTypography
                      variant="subtitle2"
                      component="p"
                      className="advice-card-title"
                      style={{
                        fontSize: "13px",
                        lineHeight: "16px",
                        marginTop: "4px",
                        color: "#212121",
                      }}>
                      {title}
                    </StyledTypography>
                  </Box>
                </SmartLink>
              );
            })}
          <StyledMenuButton onClick={onButtonClick}>
            Voir tous nos articles
            <ArrowForwardIcon />
          </StyledMenuButton>
          <Box className="mobile-inspiration-universe" mt={4}>
            <StyledTypography
              variant="h5"
              component="h5"
              style={{
                fontSize: "16px",
                lineHeight: "20px",
                color: "rgba(132, 132, 132, 1)",
                textTransform: "none",
                marginBottom: "15px",
              }}>
              Par univers
            </StyledTypography>
            {InspirationData?.univers?.map((uniData: Record<string, any>, index: number) => {
              const obfuscate = shouldObfuscate(uniData);
              return obfuscate ? (
                <div
                  key={uniData?.label + index}
                  role="link"
                  tabIndex={0}
                  style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}
                  onClick={() => {
                    onParUniverseItemClick(uniData);
                    if (uniData?.link) navigate(uniData?.link);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onParUniverseItemClick(uniData);
                      if (uniData?.link) navigate(uniData?.link);
                    }
                  }}>
                  {uniData?.icon && (
                    <ImageLayout
                      src={storeUtil.getUrlPicture(`${uniData.icon}`, "")}
                      height={24}
                      width={24}
                      styles={{ margin: "unset" }}
                    />
                  )}
                  <StyledTypography
                    variant="body1"
                    component="p"
                    style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                    {uniData?.label}
                  </StyledTypography>
                </div>
              ) : (
                <SmartLink
                  key={uniData?.label + index}
                  to={uniData?.link || ""}
                  onClick={() => onParUniverseItemClick(uniData)}
                  styles={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "20px" }}>
                  {uniData?.icon && (
                    <ImageLayout
                      src={storeUtil.getUrlPicture(`${uniData.icon}`, "")}
                      height={24}
                      width={24}
                      styles={{ margin: "unset" }}
                    />
                  )}
                  <StyledTypography
                    variant="body1"
                    component="p"
                    style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                    {uniData?.label}
                  </StyledTypography>
                </SmartLink>
              );
            })}
          </Box>
          <Box className="mobile-inspiration-par-type" mt={4}>
            <StyledTypography
              variant="h5"
              component="h5"
              style={{
                fontSize: "16px",
                lineHeight: "20px",
                color: "rgba(132, 132, 132, 1)",
                textTransform: "none",
                marginBottom: "15px",
              }}>
              Par type
            </StyledTypography>
            {InspirationData?.type?.map((parTypeData: Record<string, any>, index: number) => {
              const obfuscate = shouldObfuscate(parTypeData);
              return obfuscate ? (
                <div
                  key={parTypeData?.label + index}
                  role="link"
                  tabIndex={0}
                  style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}
                  onClick={() => {
                    onParTypeItemClick(parTypeData);
                    if (parTypeData?.link) navigate(parTypeData?.link);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onParTypeItemClick(parTypeData);
                      if (parTypeData?.link) navigate(parTypeData?.link);
                    }
                  }}>
                  {parTypeData?.icon && (
                    <ImageLayout
                      src={storeUtil.getUrlPicture(`${parTypeData.icon}`, "")}
                      height={24}
                      width={24}
                      styles={{ margin: "unset" }}
                    />
                  )}
                  <StyledTypography
                    variant="body1"
                    component="p"
                    style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                    {parTypeData?.label}
                  </StyledTypography>
                </div>
              ) : (
                <SmartLink
                  key={parTypeData?.label + index}
                  to={parTypeData?.link || ""}
                  onClick={() => onParTypeItemClick(parTypeData)}
                  styles={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "20px" }}>
                  {parTypeData?.icon && (
                    <ImageLayout
                      src={storeUtil.getUrlPicture(`${parTypeData.icon}`, "")}
                      height={24}
                      width={24}
                      styles={{ margin: "unset" }}
                    />
                  )}
                  <StyledTypography
                    variant="body1"
                    component="p"
                    style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                    {parTypeData?.label}
                  </StyledTypography>
                </SmartLink>
              );
            })}
          </Box>
        </Box>
      </MobileMenuWrapper>
    </StyledSwipeableDrawer>
  );
};

export default MobileInspirationsMenu;
